import { MDCMenu } from '@material/menu'

export default {
  setup() {
    this.menu = new MDCMenu(this.el)
  },
  destroy() {
    this.menu?.destroy()
    this.menu = null
  },
  mounted() {
    this.setup()

    this.handleEvent('toggle-menu', ({ menu_id }) => {
      if (this.el.id === menu_id && this.menu) {
        this.menu.open = !this.menu.open
      }
    })
  },
  destroyed() {
    this.destroy()
  }
}
